import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IWarehouseTransferHeader_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWarehouseTransferHeader_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetOfficeList: any[];
  GetOfficeList_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetOfficeWarehouseListTransfer_s1: any[];
  GetOfficeWarehouseListTransfer_s1_dummy: any[];
  GetOfficeWarehouseListTransfer_s2: any[];
  GetOfficeWarehouseListTransfer_s2_dummy: any[];
  HS_TransferCreate: any[];
  HS_TransferCreate_dummy: any[];
  WriteToLocalStorage: any;
  WriteToLocalStorage_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
}

export class WarehouseTransferHeader_ScreenBase extends React.PureComponent<
  IWarehouseTransferHeader_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  warehousetransferheader_803595_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_653547_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_937415_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_755865_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_497198_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "68d9b16a-4834-4924-b0d6-1019f4671156",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 588591,
          PropertyName: "value",
          Value: "Merkez Depolar Arası Transfer",
        },
        { Id: 690454, PropertyName: "value", Value: "Ofis Adı" },
        { Id: 803595, PropertyName: "placeholder", Value: "Ofis" },
        { Id: 635712, PropertyName: "value", Value: "Depo Adı" },
        { Id: 653547, PropertyName: "placeholder", Value: "Depo" },
        { Id: 402915, PropertyName: "value", Value: "Karşı Ofis Adı" },
        { Id: 937415, PropertyName: "placeholder", Value: "Karşı Ofis" },
        { Id: 982084, PropertyName: "value", Value: "Karşı Depo Adı" },
        { Id: 755865, PropertyName: "placeholder", Value: "Karşı Depo" },
        { Id: 7671, PropertyName: "value", Value: "İşlem Tarihi" },
        { Id: 497198, PropertyName: "placeholder", Value: "İşlem Tarihi" },
        { Id: 288, PropertyName: "value", Value: "Açıklama" },
        { Id: 414152, PropertyName: "placeholder", Value: "Açıklama Giriniz" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.warehousetransferheader_803595_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_653547_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_937415_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_755865_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_497198_value_kuikaDatetimeRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetOfficeList: [],
      SetValueOf: "",
      GetOfficeWarehouseListTransfer_s1: [],
      GetOfficeWarehouseListTransfer_s2: [],
      HS_TransferCreate: [],
      WriteToLocalStorage: "",
      NAVIGATE: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "warehousetransferheader",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.WarehouseTransferHeaderPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.WarehouseTransferHeaderPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferheader",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferheader",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.WarehouseTransferHeaderPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.WarehouseTransferHeaderPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      warehousetransferheader_497198_value: moment().format(
        "YYYY-MM-DDTHH:mm:ss"
      ),
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  WarehouseTransferHeaderPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferHeader/WarehouseTransferHeaderPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOfficeList = result?.data.getOfficeList;

    formVars.warehousetransferheader_803595_options = stateVars.GetOfficeList;

    formVars.warehousetransferheader_937415_options = stateVars.GetOfficeList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WarehouseTransferHeaderPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferHeaderPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_803595 =
      stateVars.GetOfficeList ?? this.state.GetOfficeList;
    stateVars.dataSource_803595 =
      stateVars.GetOfficeList ?? this.state.GetOfficeList;

    stateVars.dataSource_937415 =
      stateVars.GetOfficeList ?? this.state.GetOfficeList;
    stateVars.dataSource_937415 =
      stateVars.GetOfficeList ?? this.state.GetOfficeList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  WarehouseTransferHeaderComponent_803595_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferheader_653547_value",
        "string"
      ),
      "",
      null,
      "WarehouseCode"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferHeaderComponent_803595_onChange1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferHeaderComponent_803595_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      officeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_803595_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeCode"
          )
        ),
        "string"
      ),
      warehouseCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferHeader/WarehouseTransferHeaderComponent_803595_onChange1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOfficeWarehouseListTransfer_s1 =
      result?.data.getOfficeWarehouseListTransfer_s1;

    formVars.warehousetransferheader_653547_options =
      stateVars.GetOfficeWarehouseListTransfer_s1;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferHeaderComponent_803595_onChange2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferHeaderComponent_803595_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_653547 =
      stateVars.GetOfficeWarehouseListTransfer_s1 ??
      this.state.GetOfficeWarehouseListTransfer_s1;
    stateVars.dataSource_653547 =
      stateVars.GetOfficeWarehouseListTransfer_s1 ??
      this.state.GetOfficeWarehouseListTransfer_s1;

    stateVars.dataSource_755865 =
      stateVars.GetOfficeWarehouseListTransfer_s2 ??
      this.state.GetOfficeWarehouseListTransfer_s2;
    stateVars.dataSource_755865 =
      stateVars.GetOfficeWarehouseListTransfer_s2 ??
      this.state.GetOfficeWarehouseListTransfer_s2;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferHeaderComponent_937415_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      officeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_937415_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeCode"
          )
        ),
        "string"
      ),
      warehouseCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_653547_value",
            "value",
            "GetOfficeWarehouseListTransfer_s1",
            "warehouseCode",
            "warehouseCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferHeader/WarehouseTransferHeaderComponent_937415_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOfficeWarehouseListTransfer_s2 =
      result?.data.getOfficeWarehouseListTransfer_s2;

    formVars.warehousetransferheader_755865_options =
      stateVars.GetOfficeWarehouseListTransfer_s2;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferHeaderComponent_937415_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferHeaderComponent_937415_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_653547 =
      stateVars.GetOfficeWarehouseListTransfer_s1 ??
      this.state.GetOfficeWarehouseListTransfer_s1;
    stateVars.dataSource_653547 =
      stateVars.GetOfficeWarehouseListTransfer_s1 ??
      this.state.GetOfficeWarehouseListTransfer_s1;

    stateVars.dataSource_755865 =
      stateVars.GetOfficeWarehouseListTransfer_s2 ??
      this.state.GetOfficeWarehouseListTransfer_s2;
    stateVars.dataSource_755865 =
      stateVars.GetOfficeWarehouseListTransfer_s2 ??
      this.state.GetOfficeWarehouseListTransfer_s2;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferHeaderComponent_656886_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CreatedBy_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_414152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OfficeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_803595_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeCode"
          )
        ),
        "string"
      ),
      OfficeDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_803595_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeDescription"
          )
        ),
        "string"
      ),
      ToOfficeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_937415_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeCode"
          )
        ),
        "string"
      ),
      ToOfficeDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_937415_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeDescription"
          )
        ),
        "string"
      ),
      ToWarehouseCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_755865_value",
            "value",
            "GetOfficeWarehouseListTransfer_s2",
            "warehouseCode",
            "warehouseCode"
          )
        ),
        "string"
      ),
      ToWarehouseDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_755865_value",
            "value",
            "GetOfficeWarehouseListTransfer_s2",
            "warehouseCode",
            "warehouseDescription"
          )
        ),
        "string"
      ),
      WarehouseCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_653547_value",
            "value",
            "GetOfficeWarehouseListTransfer_s1",
            "warehouseCode",
            "warehouseCode"
          )
        ),
        "string"
      ),
      WarehouseDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferheader_653547_value",
            "value",
            "GetOfficeWarehouseListTransfer_s1",
            "warehouseCode",
            "warehouseDescription"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferHeader/WarehouseTransferHeaderComponent_656886_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_TransferCreate = result?.data.hS_TransferCreate;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferHeaderComponent_656886_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferHeaderComponent_656886_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.WriteToLocalStorage =
      await ReactSystemFunctions.writeToLocalStorage(
        ReactSystemFunctions.convertToTypeByName("TransferHeaderId", "string"),
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferCreate !== undefined
            ? stateVars.HS_TransferCreate?.length > 0
              ? stateVars.HS_TransferCreate[0].id
              : null
            : this.state.HS_TransferCreate?.length > 0
            ? this.state.HS_TransferCreate[0].id
            : null
        )
      );
    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/warehousetransferdetail") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "WarehouseTransferHeader",
      "WarehouseTransferDetail",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.WarehouseTransferHeaderPageInit();
    }
  }
}
